<template>
  <div class="boss-main-wrap boss-main-content-wrap pega-interview-form-container">
    <setting-header
      :title="`面接情報ページ${title}`"
    />
    <p class="boss-text">
      ◆面接情報ページ作成時の注意点◆
      <br>・このページで記載された内容は、サイト利用者に公開されます。個人情報や誹謗、中傷、わいせつ等公序良俗に反する内容は記載しないでください。
      <br>・本ページで作成したページにおいて、ユーザー間又はユーザーと第三者間でトラブルが発生した場合、キャリアデザインセンターは、一切責任を負いません。
    </p>
    <div>
      <h3 class="boss-joboffer-title boss-setting">
        面接情報ページ内容入力
      </h3>
      <div class="boss-table-2">
        <template-form
          label="面接情報ページ名"
          :is-required="true"
        >
          <div class="pega-interview-left-content margin-right-10-percent">
            <div data-test="name-max">
              （{{ maxLength.name }}文字以内）
            </div>
            <input
              v-model="interviewer.name"
              type="text"
              class="boss-input boss-input-fill"
              :class="{ 'is-invalid-input': isInvalidName }"
              data-test="page-label"
            >
            <validation-label
              v-if="isInvalidName"
              data-test="validation-name"
              :label="`${maxLength.name}文字以内で入力してください`"
            />
          </div>
          <div class="pega-interview-right-content">
            <div class="boss-notice-text">
              非公開
            </div>
            <div>※今回作成する面接情報を管理するための名前を記入してください</div>
            <div>（例）営業職面接情報</div>
          </div>
        </template-form>
        <template-form
          label="選考フロー・選考概要"
          :is-required="true"
          :has-child="true"
        >
          <template-form label="書類選考の有無">
            <div class="pega-interview-left-content margin-right-10-percent">
              <label
                v-for="(arinashiLabel ,i) in arinashiLabels"
                :key="i"
                class="pega-badge-radio pega-mr-5"
              >
                <input
                  v-model="interviewer.includingPaperScreening.id"
                  :data-test="`paper-screening-${i}`"
                  :value="arinashiLabel.id"
                  type="radio"
                >
                <span
                  :data-test="`paper-screening-label-${i}`"
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                >{{ arinashiLabel.name }}</span>
              </label>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
            </div>
          </template-form>
          <template-form label="性格適性・能力試験の有無">
            <div class="pega-interview-left-content margin-right-10-percent">
              <label
                v-for="(spi ,i) in spis"
                :key="i"
                class="pega-badge-radio pega-mr-5"
              >
                <input
                  v-model="interviewer.spiTest.id"
                  :data-test="`spi-test-${i}`"
                  :value="spi.id"
                  type="radio"
                >
                <span
                  :data-test="`spi-test-label-${i}`"
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                >{{ spi.name }}</span>
              </label>
              <div data-test="spi-test-note-label">
                備考 （{{ maxLength.spiTestNote }}文字以内）
              </div>
              <input
                v-model="interviewer.spiTestNote"
                type="text"
                class="boss-input boss-input-fill"
                :class="{ 'is-invalid-input': isInvalidSpiTestNote }"
                data-test="spi-test-note"
              >
              <validation-label
                v-if="isInvalidSpiTestNote"
                data-test="validation-spi-test-note"
                :label="`${maxLength.spiTestNote}文字以内で入力してください`"
              />
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
            </div>
          </template-form>
          <template-form label="デジタル応募書類可/不可">
            <div class="pega-interview-left-content margin-right-10-percent">
              <label
                v-for="(interviewAcceptableDigitalDocument ,i) in interviewAcceptableDigitalDocuments"
                :key="i"
                class="pega-badge-radio pega-mr-5"
              >
                <input
                  v-model="interviewer.enabledDigitalResume.id"
                  :data-test="`digital-resume-${i}`"
                  :value="interviewAcceptableDigitalDocument.id"
                  type="radio"
                >
                <span
                  :data-test="`digital-resume-label-${i}`"
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                >{{ interviewAcceptableDigitalDocument.name }}</span>
              </label>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
              ※選考時に、手書きではない応募書類を提出しても良い場合、「可能」を選択してください
            </div>
          </template-form>
          <template-form label="内定までの選考期間">
            <div class="pega-interview-left-content margin-right-10-percent">
              <label
                v-for="(interviewSelectionPeriod ,i) in interviewSelectionPeriods"
                :key="i"
                class="pega-badge-radio pega-mr-5"
              >
                <input
                  v-model="interviewer.selectionTerm.id"
                  :data-test="`selection-term-${i}`"
                  :value="interviewSelectionPeriod.id"
                  type="radio"
                >
                <span
                  :data-test="`selection-term-label-${i}`"
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                >{{ interviewSelectionPeriod.name }}</span>
              </label>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
              ※応募受付後～内定までに必要な期間（目処で構いません）を選択してください
            </div>
          </template-form>
          <template-form label="面接回数">
            <div class="pega-interview-left-content margin-right-10-percent">
              <label
                v-for="(step ,i) in interviewSteps"
                :key="i"
                class="pega-badge-radio pega-mr-5"
              >
                <input
                  v-model="interviewer.interviewSteps.id"
                  :data-test="`step-${i}`"
                  :value="step.id"
                  type="radio"
                >
                <span
                  :data-test="`step-label-${i}`"
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                >{{ step.name }}</span>
              </label>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
            </div>
          </template-form>
          <template-form label="面接可能な日程・時間帯">
            <div class="pega-interview-left-content margin-right-10-percent">
              <div>
                【時間帯】
                <label
                  v-for="(interviewAvailableHour ,i) in interviewAvailableHours"
                  :key="i"
                  class="pega-badge-radio pega-mr-5"
                >
                  <input
                    v-model="interviewer.interviewTimeZone.id"
                    :data-test="`time-zone-${i}`"
                    :value="interviewAvailableHour.id"
                    type="radio"
                  >
                  <span
                    :data-test="`time-zone-label-${i}`"
                    class="pega-badge-radio-text pega-badge-radio-check-mark"
                  >{{ interviewAvailableHour.name }}</span>
                </label>
              </div>
              <div>
                【曜日】
                <label
                  v-for="(interviewAvailableDay ,i) in interviewAvailableDays"
                  :key="i"
                  class="pega-badge-radio pega-mr-5"
                >
                  <input
                    v-model="interviewer.interviewDayOfTheWeek.id"
                    :data-test="`day-of-week-${i}`"
                    :value="interviewAvailableDay.id"
                    type="radio"
                  >
                  <span
                    :data-test="`day-of-week-label-${i}`"
                    class="pega-badge-radio-text pega-badge-radio-check-mark"
                  >{{ interviewAvailableDay.name }}</span>
                </label>
              </div>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
            </div>
          </template-form>
          <template-form label="面接時の服装">
            <div class="pega-interview-left-content margin-right-10-percent">
              <label
                v-for="(interviewDressCode ,i) in interviewDressCodes"
                :key="i"
                class="pega-badge-radio pega-mr-5"
              >
                <input
                  v-model="interviewer.clothes.id"
                  :data-test="`clothe-${i}`"
                  :value="interviewDressCode.id"
                  type="radio"
                >
                <span
                  :data-test="`clothe-label-${i}`"
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                >{{ interviewDressCode.name }}</span>
              </label>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
            </div>
          </template-form>
          <template-form label="面接の所要時間">
            <div class="pega-interview-left-content margin-right-10-percent">
              <select
                v-model="interviewer.timeRequired.id"
                class="boss-input-select"
                data-test="duration"
              >
                <option
                  v-for="(interviewRequiredTime ,i) in interviewRequiredTimes"
                  :key="i"
                  :value="interviewRequiredTime.id"
                  :data-test="`duration-${i}`"
                >
                  {{ interviewRequiredTime.name }}
                </option>
              </select>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                貴社求人に応募済type会員のみ公開
              </div>
            </div>
          </template-form>
        </template-form>
        <template-form
          label="質問内容・ポイント"
          :has-child="true"
        >
          <template-form
            label="一次面接の面接官について"
            required="最低1人必須"
          >
            <div class="pega-interview-left-content margin-right-10-percent">
              <div
                v-for="person in interviewer.interviewers"
                :key="person.interviewerNo"
              >
                <label :data-test="`selected-interviewer-label-${person.interviewerNo}`">
                  <input
                    v-model="selected[`isInterviewer${person.interviewerNo}`]"
                    class="boss-input-checkbox"
                    type="checkbox"
                    :data-test="`selected-interviewer-${person.interviewerNo}`"
                  >{{ person.interviewerNo }}人目
                </label>
                <div>
                  【性別】
                  <label
                    v-for="(gender ,i) in genders"
                    :key="i"
                    class="pega-badge-radio pega-mr-5"
                  >
                    <input
                      v-model="person.interviewerGender.id"
                      :data-test="`gender-${person.interviewerNo}-${i}`"
                      :value="gender.id"
                      type="radio"
                    >
                    <span
                      :data-test="`gender-label-${person.interviewerNo}-${i}`"
                      class="pega-badge-radio-text pega-badge-radio-check-mark"
                    >{{ gender.name }}</span>
                  </label>
                </div>
                <div>
                  【役職】
                  <label
                    v-for="(position ,i) in positions"
                    :key="i"
                    class="pega-badge-radio pega-mr-5"
                  >
                    <input
                      v-model="person.interviewerPosition.id"
                      :data-test="`position-${person.interviewerNo}-${i}`"
                      :value="position.id"
                      type="radio"
                    >
                    <span
                      :data-test="`position-label-${person.interviewerNo}-${i}`"
                      class="pega-badge-radio-text pega-badge-radio-check-mark"
                    >{{ position.name }}</span>
                  </label>
                </div>
                <div>
                  【年齢】
                  <label
                    v-for="(generation ,i) in generations"
                    :key="i"
                    class="pega-badge-radio pega-mr-5"
                  >
                    <input
                      v-model="person.interviewerGeneration.id"
                      :data-test="`generation-${person.interviewerNo}-${i}`"
                      :value="generation.id"
                      type="radio"
                    >
                    <span
                      :data-test="`generation-label-${person.interviewerNo}-${i}`"
                      class="pega-badge-radio-text pega-badge-radio-check-mark"
                    >{{ generation.name }}</span>
                  </label>
                </div>
              </div>
              <div class="margin-top-1">
                <div data-test="interview-note-label">
                  補足({{ maxLength.interviewerNote }}文字以内)
                </div>
                <div>※拠点ごとに面接官が異なる場合や二次面接以降の情報など、補足事項があれば記載をお願い致します。</div>
                <textarea
                  v-model="interviewer.interviewerNote"
                  data-test="interviewer-note"
                  rows="8"
                  class="margin-0 pega-textarea-resize-none"
                  :class="{ 'is-invalid-input': isInvalidInterviewerNote }"
                />
                <validation-label
                  v-if="isInvalidInterviewerNote"
                  data-test="validation-interviewer-note"
                  :label="`${maxLength.interviewerNote}文字以内で入力してください`"
                />
              </div>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                type会員のみ公開
              </div>
            </div>
          </template-form>
          <template-form
            label="一次面接の質問内容・流れ"
            required="最低1つ必須"
          >
            <div class="pega-interview-left-content margin-right-10-percent">
              <div>採用面接で、質問予定の内容を時系列で上から選択してください。</div>
              <div>※質問項目が選択肢に無い場合、「【選択してください】」を選択した上で、項目右側のテキストボックスへ質問内容をご記入ください。</div>
              <div data-test="free-comment-max">
                ※テキストボックスは{{ maxLength.freeComment }}文字以内でご記入ください
              </div>
              <div
                v-for="(interviewInformationFlow, i) in interviewer.interviewInformationFlows"
                :key="i"
                class="margin-top-1"
              >
                <select
                  v-model="interviewInformationFlow.interviewProcess.id"
                  class="boss-input-select"
                  :class="{ 'is-invalid-input': isInvalidInterviewInformationFlowSet(interviewInformationFlow) }"
                  :data-test="`duration-interview-process-${i}`"
                >
                  <option
                    :value="null"
                    :data-test="`no-process-${i}`"
                  >
                    【選択してください】
                  </option>
                  <option
                    v-for="(interviewFlow ,j) in interviewFlows"
                    :key="j"
                    :value="interviewFlow.id"
                    :data-test="`process-option-${i}-${j}`"
                  >
                    {{ interviewFlow.name }}
                  </option>
                </select><span class="margin-left-1">または、</span>
                <input
                  v-model="interviewInformationFlow.freeComment"
                  type="text"
                  class="boss-input"
                  :class="{'is-invalid-input': isInvalidInterviewInformationFlow(interviewInformationFlow)}"
                  :data-test="`interview-process-${i}`"
                >
                <validation-label
                  v-if="isInvalidFreeComment(interviewInformationFlow.freeComment)"
                  :data-test="`validation-interview-free-comment-${i}`"
                  :label="`${maxLength.freeComment}文字以内で入力してください`"
                />
                <validation-label
                  v-if="isInvalidInterviewInformationFlowSet(interviewInformationFlow)"
                  :data-test="`validation-both-interview-process-${i}`"
                  label="一次面接の質問内容に対して「選択肢」「フリー記入」両方が入力されています。どちらか片方のみ入力して下さい"
                />
                <div
                  v-if="i < interviewFlows.length - 1"
                  :key="`next-icon-${i}`"
                  :data-test="`next-icon-${i}`"
                  class="text-center pega-interview-left-content"
                >
                  ↓
                </div>
              </div>
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text">
                貴社求人に応募済type会員のみ公開
              </div>
            </div>
          </template-form>
          <template-form
            label="求職者に求める能力、重視するポイント"
            :is-required="true"
            :has-child="true"
          >
            <template-form
              label="実務能力、実績"
              data-test="skill-achievement-form"
              class="pega-interview-slider"
            >
              <vue-slider
                v-model="skillAchievement"
                :adsorb="true"
                :data="scoreLabels"
                :marks="true"
                tooltip="none"
                :width="480"
                class="margin-left-3"
              />
            </template-form>
            <template-form
              label="ビジネスマナー"
              data-test="business-manner-form"
              class="pega-interview-slider"
            >
              <vue-slider
                v-model="businessManner"
                :adsorb="true"
                :data="scoreLabels"
                :marks="true"
                tooltip="none"
                :width="480"
                class="margin-left-3"
              />
            </template-form>
            <template-form
              label="コミュニケーション能力・論理的思考力"
              data-test="communication-ability-form"
              class="pega-interview-slider"
            >
              <vue-slider
                v-model="communicationAbility"
                :adsorb="true"
                :data="scoreLabels"
                :marks="true"
                tooltip="none"
                :width="480"
                class="margin-left-3"
              />
            </template-form>
            <template-form
              label="仕事への意欲、エネルギー"
              data-test="volition-form"
              class="pega-interview-slider"
            >
              <vue-slider
                v-model="volition"
                :adsorb="true"
                :data="scoreLabels"
                :marks="true"
                tooltip="none"
                :width="480"
                class="margin-left-3"
              />
            </template-form>
            <template-form
              label="社風とのマッチ度"
              data-test="matching-form"
              class="pega-interview-slider"
            >
              <vue-slider
                v-model="matching"
                :adsorb="true"
                :data="scoreLabels"
                :marks="true"
                tooltip="none"
                :width="480"
                class="margin-left-3"
              />
            </template-form>
            <div class="boss-table-2-item">
              <div class="boss-notice-text">
                貴社求人に応募済type会員のみ公開
              </div>
              <div>重要：★5つ</div>
              <div>やや重要：★4つ</div>
              <div>どちらでもない：★3つ</div>
              <div>あまり重要ではない：★2つ</div>
              <div>重要ではない：★1つ</div>
              <div>で掲載されます</div>
            </div>
          </template-form>
          <interview-checkpoint-form
            v-for="(interviewInformationCheckpoint,i) in interviewer.interviewInformationCheckpoints"
            :key="interviewInformationCheckpoint.checkpointCategoryId"
            :data-test="`interviewInformationCheckpoint-${i}`"
            :checkpoint-category-id="interviewInformationCheckpoint.checkpointCategoryId"
            :checkpoint-details="interviewInformationCheckpoint.checkpointDetails"
            @update-checkpoint-details="updateCheckpointDetails"
          />
          <template-form label="活躍中社員からの面接アドバイス">
            <div class="pega-interview-left-content">
              <div data-test="advice-max">
                （{{ maxLength.advice }}文字以内）
              </div>
              <textarea
                v-model="interviewer.advice"
                data-test="advice"
                rows="6"
                class="pega-interview-text-area pega-textarea-resize-none"
                :class="{'is-invalid-input': isInvalidAdvice}"
              />
              <validation-label
                v-if="isInvalidAdvice"
                data-test="validation-advice"
                :label="`${maxLength.advice}文字以内で入力してください`"
              />
            </div>
            <div class="pega-interview-right-content">
              <div class="boss-notice-text padding-left-1">
                貴社求人に応募済type会員のみ公開
              </div>
            </div>
          </template-form>
        </template-form>
      </div>
    </div>
    <div class="boss-layout boss-layout-center margin-vertical-1">
      <button
        :disabled="isDisabled"
        data-test="confirmation"
        class="boss-button boss-button-confirm pega-button"
        @click="onSubmit(false)"
      >
        <span
          class="boss-button-confirm-text"
          data-test="confirm-button"
        >
          保存して後で掲載する </span>
      </button>
      <button
        :disabled="isDisabled"
        data-test="confirmation-to-setting"
        class="boss-button boss-button-confirm pega-button"
        @click="onSubmit(true)"
      >
        <span
          class="boss-button-confirm-text"
          data-test="confirmation-to-setting-button"
        >
          保存して掲載へ進む(掲載求人の設定) </span>
      </button>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import TemplateForm from '@/components/atoms/TemplateForm'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import InterviewCheckpointForm from '@/components/molecules/InterviewCheckpointForm'
import { interviewer } from '@/lib/labelValueMappings'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import VueSlider from 'vue-slider-component'
const USER_URL = process.env.USER_ENDPOINT

export default {
  components: {
    SettingHeader,
    TemplateForm,
    VueSlider,
    ValidationLabel,
    InterviewCheckpointForm
  },
  props: {
    interviewCountermeasureId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      interviewerOptions: interviewer,
      interviewer: {
        name: '',
        includingPaperScreening: {
          id: 1
        },
        spiTest: {
          id: 1
        },
        enabledDigitalResume: {
          id: 2
        },
        selectionTerm: {
          id: 1
        },
        interviewSteps: {
          id: 1
        },
        interviewTimeZone: {
          id: 1
        },
        interviewDayOfTheWeek: {
          id: 1
        },
        clothes: {
          id: 1
        },
        timeRequired: {
          id: 1
        },
        interviewers:
        [...Array(3)].map((__, i) =>
          ({
            interviewerNo: i + 1,
            interviewerGender: {
              id: 1
            },
            interviewerPosition: {
              id: 1
            },
            interviewerGeneration: {
              id: 1
            }
          })
        ),
        interviewInformationFlows:
        [...Array(13)].map((__, i) =>
          ({
            flowNo: i + 1,
            interviewProcess: {
              id: null
            },
            freeComment: ''
          })
        ),
        skillAchievementId: 3,
        businessMannerId: 3,
        communicationAbilityId: 3,
        volitionId: 3,
        matchingId: 3,
        interviewInformationCheckpoints:
        [...Array(3 + 1).keys()].slice(1).map((categoryId) => ({
          checkpointCategoryId: categoryId,
          checkpointDetails: [...Array(3 + 1).keys()].slice(1).map((detailNo) => ({
            checkpointNo: detailNo,
            summary: '',
            contents: ''
          }))
        })),
        advice: '',
        spiTestNote: '',
        interviewerNote: ''
      },
      selected: {
        isInterviewer1: false,
        isInterviewer2: false,
        isInterviewer3: false
      },
      isInvalidCheckpointDetails: false
    }
  },
  computed: {
    userEndPoint: () => USER_URL,
    maxLength () {
      return {
        name: 100,
        spiTestNote: 150,
        interviewerNote: 1000,
        freeComment: 60,
        advice: 600
      }
    },
    title () {
      return this.interviewCountermeasureId ? '更新' : '新規入稿'
    },
    requestInterviewer () {
      const params = _.cloneDeep(this.interviewer)
      //  選択されていない一次面接の面接官には除外
      params.interviewers = params.interviewers.filter(interviewers => {
        return (this.selected[`isInterviewer${interviewers.interviewerNo}`])
      })
      params.interviewInformationFlows = params.interviewInformationFlows.filter(flow => {
        return !(flow.interviewProcess.id === null && flow.freeComment.length === 0)
      })
      // 概要と理由の両方に記載がない面接の中で見ているポイント1～3、不採用になる方の傾向1～3、必ず質問すること1～3は除外
      params.interviewInformationCheckpoints = params.interviewInformationCheckpoints.map(checkpoint => {
        return {
          checkpointCategoryId: checkpoint.checkpointCategoryId,
          checkpointDetails: checkpoint.checkpointDetails.filter(detail => detail.summary !== '' && detail.contents !== '')
        }
      })

      return params
    },
    ...mapGetters({
      arinashiLabels: 'arinashiLabelsMaster',
      spis: 'spisMaster',
      interviewAcceptableDigitalDocuments: 'interviewAcceptableDigitalDocumentsMaster',
      interviewSelectionPeriods: 'interviewSelectionPeriodsMaster',
      interviewSteps: 'interviewStepsMaster',
      interviewAvailableHours: 'interviewAvailableHoursMaster',
      interviewAvailableDays: 'interviewAvailableDaysMaster',
      interviewDressCodes: 'interviewDressCodesMaster',
      interviewRequiredTimes: 'interviewRequiredTimesMaster',
      genders: 'genderMaster',
      positions: 'positionsMaster',
      generations: 'generationsMaster',
      interviewFlows: 'interviewFlowsMaster',
      interviewImportances: 'interviewImportancesMaster',
      interviewCheckpointCategories: 'interviewCheckpointCategoriesMaster'
    }),
    scoreLabels () {
      return this.interviewImportances.slice().sort((a, b) => a.id - b.id).map(option => option.name)
    },
    skillAchievement: {
      get () {
        return _.find(this.interviewImportances, interviewImportances => _.isEqual(this.interviewer.skillAchievementId, interviewImportances.id)).name
      },
      set (value) {
        this.$set(this.interviewer, 'skillAchievementId', _.find(this.interviewImportances, interviewImportances => _.isEqual(value, interviewImportances.name)).id)
      }
    },
    businessManner: {
      get () {
        return _.find(this.interviewImportances, interviewImportances => _.isEqual(this.interviewer.businessMannerId, interviewImportances.id)).name
      },
      set (value) {
        this.$set(this.interviewer, 'businessMannerId', _.find(this.interviewImportances, interviewImportances => _.isEqual(value, interviewImportances.name)).id)
      }
    },
    communicationAbility: {
      get () {
        return _.find(this.interviewImportances, interviewImportances => _.isEqual(this.interviewer.communicationAbilityId, interviewImportances.id)).name
      },
      set (value) {
        this.$set(this.interviewer, 'communicationAbilityId', _.find(this.interviewImportances, interviewImportances => _.isEqual(value, interviewImportances.name)).id)
      }
    },
    volition: {
      get () {
        return _.find(this.interviewImportances, interviewImportances => _.isEqual(this.interviewer.volitionId, interviewImportances.id)).name
      },
      set (value) {
        this.$set(this.interviewer, 'volitionId', _.find(this.interviewImportances, interviewImportances => _.isEqual(value, interviewImportances.name)).id)
      }
    },
    matching: {
      get () {
        return _.find(this.interviewImportances, interviewImportances => _.isEqual(this.interviewer.matchingId, interviewImportances.id)).name
      },
      set (value) {
        this.$set(this.interviewer, 'matchingId', _.find(this.interviewImportances, interviewImportances => _.isEqual(value, interviewImportances.name)).id)
      }
    },
    isInvalidName () {
      return this.interviewer.name.length > this.maxLength.name
    },
    isInvalidSpiTestNote () {
      return this.interviewer.spiTestNote.length > this.maxLength.spiTestNote
    },
    isInvalidInterviewers () {
      return !Object.keys(this.selected).some(interviewer => this.selected[interviewer])
    },
    isInvalidInterviewerNote () {
      return this.interviewer.interviewerNote.length > this.maxLength.interviewerNote
    },
    isInvalidAdvice () {
      return this.interviewer.advice.length > this.maxLength.advice
    },
    isInvalidInterviewInformationFlows () {
      return this.interviewer.interviewInformationFlows
        .some(interviewInformationFlow => this.isInvalidInterviewInformationFlow(interviewInformationFlow)) ||
      this.interviewer.interviewInformationFlows
        .every(interviewInformationFlow =>
          interviewInformationFlow.interviewProcess.id === null && !interviewInformationFlow.freeComment
        )
    },
    isDisabled () {
      return !this.interviewer.name.length ||
      this.isInvalidName ||
      this.isInvalidSpiTestNote ||
      this.isInvalidInterviewers ||
      this.isInvalidInterviewerNote ||
      this.isInvalidInterviewInformationFlows ||
      this.isInvalidCheckpointDetails ||
      this.interviewer.interviewInformationCheckpoints[0].checkpointDetails
        .every(detail => _.isEmpty(detail.summary) && _.isEmpty(detail.contents)) ||
      this.isInvalidAdvice
    }
  },
  mounted () {
    this.interviewCountermeasureId && this.fetchInterviewCountermeasure()
  },
  methods: {
    fetchInterviewCountermeasure () {
      this.$http.secured.get(`/interview_countermeasures/${this.interviewCountermeasureId}`).then(response => {
        this.setInterviewer(response.data)
      })
    },
    setInterviewer (interviewer) {
      // バックエンドからobject自体がnullの場合があるため初期値をいれたりする用
      this.$set(this.interviewer, 'name', interviewer.name)
      this.$set(this.interviewer.includingPaperScreening, 'id', _.get(interviewer.includingPaperScreening, 'id', 1))
      this.$set(this.interviewer.spiTest, 'id', _.get(interviewer.spiTest, 'id', 1))
      this.$set(this.interviewer.enabledDigitalResume, 'id', _.get(interviewer.enabledDigitalResume, 'id', 2))
      this.$set(this.interviewer.selectionTerm, 'id', _.get(interviewer.selectionTerm, 'id', 1))
      this.$set(this.interviewer.interviewSteps, 'id', _.get(interviewer.interviewSteps, 'id', 1))
      this.$set(this.interviewer.interviewTimeZone, 'id', _.get(interviewer.interviewTimeZone, 'id', 1))
      this.$set(this.interviewer.interviewDayOfTheWeek, 'id', _.get(interviewer.interviewDayOfTheWeek, 'id', 1))
      this.$set(this.interviewer.clothes, 'id', _.get(interviewer.clothes, 'id', 1))
      this.$set(this.interviewer.timeRequired, 'id', _.get(interviewer.timeRequired, 'id', 1))
      this.$set(this.interviewer, 'skillAchievementId', interviewer.skillAchievementId)
      this.$set(this.interviewer, 'businessMannerId', interviewer.businessMannerId)
      this.$set(this.interviewer, 'communicationAbilityId', interviewer.communicationAbilityId)
      this.$set(this.interviewer, 'volitionId', interviewer.volitionId)
      this.$set(this.interviewer, 'matchingId', interviewer.matchingId)
      this.$set(this.interviewer, 'advice', interviewer.advice)
      this.$set(this.interviewer, 'spiTestNote', interviewer.spiTestNote)
      this.$set(this.interviewer, 'interviewerNote', interviewer.interviewerNote)
      this.$set(this.interviewer, 'interviewers', interviewer.interviewers)
      this.setInterviewersData()
      // 一次面接の質問内容・流れ
      this.$set(this.interviewer, 'interviewInformationFlows', interviewer.interviewInformationFlows)
      this.setInterviewInformationFlowsData()
      // 面接の中で見ているポイント1～3、不採用になる方の傾向1～3、必ず質問すること1～3
      this.$set(this.interviewer, 'interviewInformationCheckpoints', interviewer.interviewInformationCheckpoints)
      this.setInterviewInformationCheckpointsData()
    },
    setInterviewersData () {
      const allInterviewers = [...Array(3 + 1).keys()].slice(1).map((no) => {
        const existingInterviewer = this.interviewer.interviewers.find(interviewer => interviewer.interviewerNo === no)
        if (existingInterviewer) {
          this.$set(this.selected, `isInterviewer${no}`, true)
          return existingInterviewer
        } else {
          return {
            interviewerNo: no,
            interviewerGender: { id: 1 },
            interviewerPosition: { id: 1 },
            interviewerGeneration: { id: 1 }
          }
        }
      })
      this.$set(this.interviewer, 'interviewers', allInterviewers)
    },
    setInterviewInformationFlowsData () {
      // 「一次面接の質問内容・流れ」No.1 ~ No.13を配列で生成する
      const allInterviewInformationFlows = [...Array(13 + 1).keys()].slice(1).map((no) => {
        const existingFlow = this.interviewer.interviewInformationFlows.find(flow => flow.flowNo === no)
        return existingFlow || {
          flowNo: no,
          interviewProcess: { id: null },
          freeComment: ''
        }
      })
      this.$set(this.interviewer, 'interviewInformationFlows', allInterviewInformationFlows)
    },
    setInterviewInformationCheckpointsData () {
      // 面接の中で見ているポイント1～3、不採用になる方の傾向1～3、必ず質問すること1～3を生成
      const allInterviewInformationCheckpoints = [...Array(3 + 1).keys()].slice(1).flatMap((categoryId) => {
        const checkpointDetails = [...Array(3 + 1).keys()].slice(1).map((pointNo) => {
          const existingCheckpoints = this.interviewer.interviewInformationCheckpoints.find(
            checkpoint => checkpoint.checkpointCategoryId === categoryId &&
            checkpoint.checkpointDetails.some(detail => detail.checkpointNo === pointNo))
          return existingCheckpoints ? existingCheckpoints.checkpointDetails.find(detail => detail.checkpointNo === pointNo) : {
            checkpointNo: pointNo,
            summary: '',
            contents: ''
          }
        })
        return {
          checkpointCategoryId: categoryId,
          checkpointDetails: checkpointDetails
        }
      })
      this.$set(this.interviewer, 'interviewInformationCheckpoints', allInterviewInformationCheckpoints)
    },
    onSubmit (isSettings) {
      this.$emit('submit', { isSettings: isSettings, params: this.requestInterviewer })
    },
    updateCheckpointDetails (updateCheckpointDetail) {
      const checkpointCategoryIndex = updateCheckpointDetail.checkpointCategoryId - 1
      const checkpointDetailIndex = updateCheckpointDetail.checkpointNo - 1
      const changeTarget = this.interviewer.interviewInformationCheckpoints[checkpointCategoryIndex].checkpointDetails[checkpointDetailIndex]

      this.$set(changeTarget, 'summary', updateCheckpointDetail.summary)
      this.$set(changeTarget, 'contents', updateCheckpointDetail.contents)
      this.$set(changeTarget, 'isInvalid', updateCheckpointDetail.isInvalid)

      this.$set(this, 'isInvalidCheckpointDetails', this.interviewer.interviewInformationCheckpoints
        .some(category => category.checkpointDetails.some(detail => detail.isInvalid))
      )
    },
    isInvalidInterviewInformationFlowSet (interviewInformationFlow) {
      return interviewInformationFlow.interviewProcess.id !== null && !!interviewInformationFlow.freeComment.length
    },
    isInvalidFreeComment (freeComment) {
      return freeComment.length > this.maxLength.freeComment
    },
    isInvalidInterviewInformationFlow (interviewInformationFlow) {
      return this.isInvalidInterviewInformationFlowSet(interviewInformationFlow) || this.isInvalidFreeComment(interviewInformationFlow.freeComment)
    }
  }
}
</script>
